import { autobind } from 'core-decorators';
import { BaseController } from '@Controller';
import Middle from './middle/middle.vue';
import Left from './left';
import LandFeature from '../components/LandFeature'; // 地块图形组件

@autobind
class MainController extends BaseController {
    constructor(MixMapModule) {
        super();
        this.MixMapModule = MixMapModule;
    }

    static getConfig() {
        return {};
    }

    static getVMConfig(config, self) {
        return {
            data() {
                return {
                    ...config,
                    landList: [],
                    landRangeList: [],
                    contentType: 1,
                };
            },
        };
    }

    static getInput() {
        return {
            map: {
                renderFun: 'renderMap',
            },
        };
    }

    static getOutput(self) {
        return {
            Left: {
                component: Left,
                attribute() {
                    return {
                        props: {
                            onLandList: self._onLandList,
                        },
                        on: {
                            treeChildreClick: (data) => {
                                let { latitude, longitude } = data;
                                if (latitude && longitude) {
                                    longitude = Number(longitude);
                                    latitude = Number(latitude);
                                    self.MixMapModule.toCenter([longitude, latitude]);
                                }
                                // 地图对应的地块闪烁
                                self.vm.$refs.LandFeature.selectFeatureById(data.id);
                            },
                        },
                    };
                },
            },
            Middle: {
                component: Middle,
                attribute() {
                    let attr = {
                        props: {
                            renderMap: self.renderMap,
                            landList: self.vm.landList,
                            type: self.vm.contentType,
                        },
                        on: {
                            changeContentType(val) {
                                // 地图模式、图册模式类型切换事件，val的值1 ：地图 val的值2 :图册
                                self.vm.contentType = val;
                            },
                        },
                    };
                    return attr;
                },
            },
            LandFeature: {
                component: LandFeature,
                attribute() {
                    return {
                        props: {
                            rangeData: self.vm.landRangeList,
                            idKey: 'landId',
                        },
                        ref: 'LandFeature',
                        on: {
                            selectFeature: (id) => {
                                const router = self.vm.$refs.LandFeature.$router;
                                let landList = self.vm.landList;
                                let target = landList.find((land) => land.id === id);
                                if (router) {
                                    let name = '';
                                    if (target) {
                                        name = target.name;
                                    }
                                    router.push({ path: '/jiwei/land/detail', query: { id, name } });
                                }
                            },
                        },
                    };
                },
            },
        };
    }

    // eslint-disable-next-line class-methods-use-this
    _onLandList(data) {
        console.log(data);
        this.vm.landList = data || [];
        let rangeList = [];
        data.forEach((item) => {
            let landRange = item.landRange;
            landRange = JSON.parse(landRange);
            landRange.forEach((range) => {
                range.landId = item.id;
            });
            rangeList = rangeList.concat(landRange);
        });
        this.vm.landRangeList = rangeList;
    }
}

export default MainController;
